import { ComponentPropsWithoutRef, createElement, useEffect, useRef } from 'react';
interface IRichContent extends ComponentPropsWithoutRef<'div'> {
  html: string;
  allowRerender: boolean;
}
const RichContent = ({
  html,
  allowRerender,
  ...rest
}: IRichContent) => {
  const divRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (!html || !divRef.current) return;
    if (!isFirstRender.current) return;
    isFirstRender.current = Boolean(allowRerender);
    const slotHtml = document.createRange().createContextualFragment(html);
    divRef.current.innerHTML = '';
    divRef.current.appendChild(slotHtml);
  }, [html, divRef]);
  return createElement('div', {
    ...rest,
    ref: divRef
  });
};
export default RichContent;